var Label_Anime = {
	init:function(){

		var _targets = $("textarea, input[type='text'], input[type='password'], input[type='email'], input[type='tel']");

		_targets.focus(function(){
      if ($(this).parent().hasClass("password-input")) {
        $(this).parent().parent().addClass('focused');
      } else {
        $(this).parent().addClass('focused');
      }
		});

		_targets.blur(function(){
			var inputValue = $(this).val();
			if ( inputValue == "" ) {
				$(this).removeClass('filled');
        if ($(this).parent().hasClass("password-input")) {
          $(this).parent().parent().removeClass("focused");
        } else {
          $(this).parent().removeClass("focused");
        }
			} else {
				$(this).addClass('filled');
			}
		});

		_targets.each(function(){
			/*Debug.log("Test all input :  " + $(this).parent().attr("class") + ' => _' + $(this).val() + "_" );*/
			if($(this).val() != ""){
				$(this).parent().addClass('focused');
			}
		});
	}
}

$(window).load(function(){
	if($("input, textarea").length){
		Label_Anime.init();
	}
})
